const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    cursor: "none !important",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    backgroundColor: "#E7E6E2",
    opacity: "96%",
  },
  p: {
    color: "rgba(0,0,0,.5)",
    fontSize: "24px",
    margin: "15px",
    transition: "all 0.3s",
    "&:hover": {
      color: "rgba(0,0,0,1)",
    },
    lineHeight: "26px",
    letterSpacing: "0.01em",
    fontFamily: "Montserrat",
    cursor: "none !important",
    fontWeight: 700,
    textDecoration: "none",
    textTransform: "uppercase",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      fontSize: "1rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 500)]: {
      lineHeight: "1rem",
    },
  },
  closeIcon: {
    position: "absolute",
    top: "40px",
    cursor: "none !important",
    right: "60px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      top: "18px",
      right: "10px",
    },
  },
  rotate: {
    animation: "rotateOnView 1s forwards",
  },
  pActive: {
    color: "black",
  },
});

export default styles;
